import { render, staticRenderFns } from "./DaftarDisposisi.vue?vue&type=template&id=95757798&"
import script from "./DaftarDisposisi.vue?vue&type=script&lang=js&"
export * from "./DaftarDisposisi.vue?vue&type=script&lang=js&"
import style0 from "./DaftarDisposisi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports